import { Message, MessageBox, Loading, Button, Dialog } from 'element-ui'
import '@/style/element-variables.scss'

export default (Vue) => {
  Vue.use(Button)
  Vue.use(Loading)
  Vue.use(Dialog)
  Vue.prototype.$message = Message
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$loading = Loading
}
